<template>
  <div class="message_read clearfix p_background">
		<h3 class="all_title">
			<router-link to="/message_list" >返回</router-link>
		</h3>
		<section class="all_container container_box">
			
			<!--message container start-->
			
			<section class="message_container word-bw clearfix">
				<h2 class="message_container_title text-center">{{title}}</h2>
				<p class="text-center"><small class="tip_sub_text">{{publishTime | datetime}}</small></p>
				<p>{{content}}</p>
			</section>
			
			<!--message container end-->
  	</section>
  </div>
</template>

<script>
	export default {
	  name: 'message_read',
	  data () {
	    return {
	    	title:'',
	    	publishTime:'',
	    	content:''
	    }
	  },
	  mounted: function () {
	  		this.$nextTick(function(){
	  				//初始化消息详情
						this.getMessageDetail();
	  			})
	  		},
	  methods:{
	  	//获取消息详情
	    getMessageDetail(){
	    	var temp = this;
	    	var id=this.$route.params.messageId;
	      this.$http.post('/zklccloud/findTCloudMessageById',{"id":id},{emulateJSON:true}).then(function(m){
	      	this.title=m.data.messageTitle;
	      	this.publishTime=m.data.messageSendTime;
	      	this.content=m.data.messageComment;
	      	var loginType=this.$store.getters.getUserType;
	      	this.$store.dispatch('setMessageTopList', loginType);
  				this.$store.dispatch('setMCount', loginType);
	      })
	    },
	  },
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// read_message.vue?0a0355fe